import WorkOrder from '../components/WorkOrder';

export default {
    WorkOrder: {
        component: WorkOrder,
        path: '/'
    }
};